module.exports = __webpack_public_path__ + "static/img/10areaA_01.a6d6f23.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/10areaA_01.png
// module id = 878
// module chunks = 1